import { BugReport } from "@mui/icons-material";
import { Card, Grid } from "@mui/material";
import CustomDialog from "components/shared/Dialog/CustomDialog";
import { commandTypes } from "components/utils";
import { OS, TOPICS } from "components/utils/enums";
import { handleDownloadCsv, handlePrintCsv } from "components/utils/handlers";
import { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setupSingleAppsSocket, unSubscribeSocketTopics } from "../../../redux/saga/socket";
import { applicationsActions } from "../../../redux/slice/applications.slice";
import { devicesActions } from "../../../redux/slice/devices.slice";
import { packagesActions } from "../../../redux/slice/packages.slice";
import UninstallIcon from "../../../static/svgs/uninstall";
import CustomTitle from "../../shared/CustomTitle";
import MyTable from "../../shared/Tables/MyTable/MyTable";
import MyTableToolbar from "../../shared/Tables/MyTable/MyTableToolbar";
import shared from "../../shared/shared.module.scss";
import MalwareSearch from "./MalwareSearch";
import TotalApps from "./TotalApps";
import { handleDeleteApps, LINUX_APP_DOWNLOAD_COLS, linuxAppColumns, systemAppsColumns,linuxSystemAppColumns, WINDOWS_APP_DOWNLOAD_COLS, WINDOWS_SYSTEM_APP_DOWNLOAD_COLS, windowsAppColumns } from "./helper";
import { authActions } from "../../../redux/slice/auth.slice";
import { accessActions } from "../../../redux/slice/access.slice";
import { checkSinglePermission } from "components/shared/helper";
import { USER_PERMISSIONS } from "../Management/AccessManagement/helper";

const AppsContainer = () => {

  const [appSearchTerm, setAppSearchTerm] = useState("");
  const [packageSearchTerm, setPackageSearchTerm] = useState("");
  const selectedDevice = useSelector(devicesActions.selectors.getSelectedDevice);
  const currentUser = useSelector(authActions.selectors.getCurrentUser);
  const userPermissions = useSelector(accessActions.selectors.getUserPermissions)

  const applications = useSelector(
    applicationsActions.selectors.getCombineApps
  );
  const packages = useSelector(packagesActions.selectors.getPackages);
  const dispatch = useDispatch();

  const userAppColumns = useMemo(() => {
    return selectedDevice?.systemDetails?.os === OS.windows ? windowsAppColumns : linuxAppColumns
  }, [selectedDevice?.systemDetails?.os]);


  const userSystemAppsColumns = useMemo(() => {
    return selectedDevice?.systemDetails?.os === OS.windows ? systemAppsColumns : linuxSystemAppColumns
  }, [selectedDevice?.systemDetails?.os]);

  const userAppDownloadColumns = useMemo(() => {
    return selectedDevice?.systemDetails?.os === OS.windows ? WINDOWS_APP_DOWNLOAD_COLS : LINUX_APP_DOWNLOAD_COLS
  }, [selectedDevice?.systemDetails?.os]);

  const handleAppSearch = (term) => setAppSearchTerm(term);
  const handlePackageSearch = (term) => setPackageSearchTerm(term);

  const [selectedUserApps, setSelectedUserApps] = useState([]);
  const [selectedSystemApps, setSelectedSystemApps] = useState([]);

  const handleUserAppsSelection = (ids) => {
    setSelectedUserApps(ids);
  };

  const handleSystemAppsSelection = (ids) => {
    setSelectedSystemApps(ids);
  };

  const handleDeleteUserApps = () => {
    handleDeleteApps(
      {
        selectedApps: selectedUserApps,
        filteredData: applications,
        dispatchAction: applicationsActions.actions.setApplications,
        dispatch,
        selectedDevice,
        keyName: "name",
        command: commandTypes.UN_INST_SYSTEM_APP
      }
    );
  };

  const handleDeleteSystemApps = () => {
    handleDeleteApps(
      selectedSystemApps,
      filteredPackages,
      packagesActions.actions.setPackages,
      dispatch,
      selectedDevice
    );
  };

  useEffect(() => {
    setupSingleAppsSocket(dispatch);
    return () => {
      unSubscribeSocketTopics([
        TOPICS.SYSTEM_PACKAGES,
        TOPICS.APPLICATIONS
      ]);
    };
  }, [dispatch]);


  const filterRows = (rows, searchTerm) => {
    if (!searchTerm) return rows;

    const regex = new RegExp(searchTerm, "i");
    return rows.filter((row) =>
      Object.values(row).some((value) => regex.test(value))
    );
  };

  const filteredApplications = useMemo(() => {
    return filterRows(applications, appSearchTerm);
  }, [applications, appSearchTerm]);



  const filteredPackages = useMemo(() => {
    return filterRows(packages, packageSearchTerm);
  }, [packages, packageSearchTerm]);


  const [openMalwareSearch, setOpenMalwareSearch] = useState(false);
  const handleMalwareSearchOpen = () => {
    setOpenMalwareSearch(true)
  }
  const handleMalwareSearchClose = () => {
    setOpenMalwareSearch(false)
    dispatch(applicationsActions.actions.setMalwareApps({}))
  }

  debugger;
  return (
    <div>
      {/* <TotalApps os={selectedDevice?.systemDetails?.os} applications={selectedDevice?.systemDetails?.os === "Ubuntu" ? filteredPackages : filteredApplications} packages={packages} /> */}
      <Grid my={"10px"} container spacing={2}>
        <Grid item xs={12} className={shared.tableContainer}>
          <CustomTitle title={"User Apps"} count={filteredApplications?.length} />
          <Card>
            <MyTableToolbar
              placeHolder={"Search For Apps"}
              btn2Txt={checkSinglePermission(USER_PERMISSIONS.UNINSTALL_APPLICATION, userPermissions, currentUser?.role) ? "Uninstall" : null}
              btn1Txt={"Scan Malware Apps"}
              btn1Icon={BugReport}
              handleBtn1Click={handleMalwareSearchOpen}
              btn2Icon={UninstallIcon}
              onSearch={handleAppSearch}
              handleBtn2Click={handleDeleteUserApps}
              onDownload={() => handleDownloadCsv({ rows: filteredApplications, columns: userAppDownloadColumns, name: `${selectedDevice?.deviceName}_user_apps`, isDevice: true })}
              onPrint={() => handlePrintCsv(filteredApplications, userAppDownloadColumns)}
              isUninstall={false}
            />
            <MyTable
              checkboxSelection={true}
              columns={userAppColumns}
              rows={filteredApplications}
              handleSelectedRows={handleUserAppsSelection}
            />
          </Card>
        </Grid>
          <Grid item xs={12} className={shared.tableContainer}>
            <CustomTitle title={"System Apps"} count={filteredPackages?.length} />
            <Card>
              <MyTableToolbar
                placeHolder={"Search For Apps"}
                btn1Txt={false}
                btn2Txt={false}
                btn2Icon={UninstallIcon}
                onSearch={handlePackageSearch}
                handleBtn2Click={handleDeleteSystemApps}
                onDownload={() => handleDownloadCsv({ rows: filteredPackages, columns: WINDOWS_SYSTEM_APP_DOWNLOAD_COLS, name: `${selectedDevice?.deviceName}_system_apps`, isDevice: true })}
                onPrint={() => handlePrintCsv({ rows: filteredPackages, columns: WINDOWS_SYSTEM_APP_DOWNLOAD_COLS, name: `${selectedDevice?.deviceName}_system_apps`, isDevice: true })}
                isUninstall={false}
              />
              <MyTable
                isMultiLine={true}
                checkboxSelection={true}
                columns={userSystemAppsColumns}
                rows={filteredPackages}
                handleSelectedRows={handleSystemAppsSelection}
              />
            </Card>
          </Grid>
      </Grid>
      <br />

      <CustomDialog title="Search Malware App" isOpen={openMalwareSearch} handleToggle={handleMalwareSearchClose} maxWidth={"lg"}>
        <MalwareSearch handleClose={handleMalwareSearchClose} />
      </CustomDialog>
    </div>
  );
};

export default AppsContainer;
